var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v(_vm._s(_vm.chargerName)+" Status Report")]),(_vm.chargerName)?_c('charger-tabs',{attrs:{"charger-name":_vm.chargerName}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }